// extracted by mini-css-extract-plugin
export default {"header":"userMessage_header__6+qpq","date":"userMessage_date__U42ba","author":"userMessage_author__wmWN8","text":"userMessage_text__OXEkh"};